import Vue from 'vue';
import { callWaiterRequest } from './api';

const initialState = {
  callWaiterStatus: 'idle',
};

export default {
  state: initialState,
  mutations: {
    setCallWaiterStatus(state, status) {
      state.callWaiterStatus = status;
    },
  },
  actions: {
    async callWaiter(
      { commit, rootState, dispatch },
      { orderNumber, comment }
    ) {
      try {
        commit('setCallWaiterStatus', 'loading');
        const { session } = rootState;

        await callWaiterRequest({ session, orderNumber, comment });

        commit('setCallWaiterStatus', 'idle');
        dispatch('showToastInstantly', {
          title: Vue.i18n.translate('components.callWaiter.toast.title'),
          description: Vue.i18n.translate(
            'components.callWaiter.toast.description'
          ),
        });
      } catch (error) {
        commit('setCallWaiterStatus', 'idle');

        dispatch('showToastInstantly', {
          title: Vue.i18n.translate('components.callWaiter.errorToast.title'),
          isError: true,
          description: Vue.i18n.translate(
            'components.callWaiter.errorToast.description'
          ),
        });
        console.error(error);
      }
    },
  },
};
